document.addEventListener('DOMContentLoaded', function(){

	// Постройка графиков
	google.charts.load('current', {packages: ['corechart', 'line']});
	google.charts.setOnLoadCallback(drawLineColors);

	var charts = {};

	function drawLineColors() {

		let graphs = document.querySelectorAll('[data-google-graph]');

		graphs.forEach(function(item){

			fetch(item.dataset.href, {
				method: 'post',
			}).then(response => {
				return response.json();
			}).then(json => {

				//alert(json.columns);
				var data = new google.visualization.DataTable();
				json.columns.forEach(function(column){
					data.addColumn(column.type, column.name);
				});
				data.addRows(json.rows);

				var options = {
					legend: { position: 'top' },
					pointSize: 5,
					curveType: 'function',
					hAxis: {
						textStyle: {
							fontSize: 11
						}
					}					
				}

				if (json.influence != 1) {
					var indi = json.columns.length - 2;
					if (indi == 2) {
						options.series = {
							2: {targetAxisIndex: 1}
						}
					} else {
						options.series = {
							1: {targetAxisIndex: 1}
						}
					}
				}

				var chart = new google.visualization.LineChart(item);
				chart.draw(data, options);

				// Сохраняем в объект графиков, чтобы потом можно было полуить доступ
				var obj = {};
				obj.data = data;
				obj.chart = chart;
				obj.options = options;
				charts[item.getAttribute('id')] = obj;

				let pngBtn = document.getElementById(item.getAttribute('id')+'_pngbutton');
				if (pngBtn) {
					pngBtn.setAttribute('href', chart.getImageURI())
				}
			});
		});		
	}

});